'use client';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import data from '../../../data/innerpages/portfolio/latestcases';
import mixitup from 'mixitup';

function LatestCases() {
  const { t } = useTranslation('portfolio');
  const [activeFilter, setActiveFilter] = useState('All');
  const mixitupContainerRef = useRef(null);
  
  // Get translated apartment data
  const apartmentsData = t('latestCases.apartments', { returnObjects: true });

  useEffect(() => {
    const initializeMixitup = () => {
      mixitup(mixitupContainerRef.current, {
        load: {
          sort: 'order:asc',
        },
        animation: {
          duration: 700,
        },
        classNames: {
          block: 'filter',
          elementFilter: 'filter-btn',
          elementSort: 'sort-btn',
        },
        selectors: {
          target: '.mix-item',
        },
      });
    };

    initializeMixitup();
  }, []);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);

    document.querySelectorAll('.filter-btn').forEach((btn) => {
      btn.classList.remove('active');
    });

    const clickedButton = document.querySelector(`[data-filter=".${filter}"]`);
    if (clickedButton) {
      clickedButton.classList.add('active');
    }
  };

  return (
    <section className="tc-latest-cases-style1">
      <div className="container">
        <div className="content">
          <h3 className="fsz-45 text-capitalize mb-90 ">
            {t('latestCases.title')}
          </h3>
          <div className="cases">
            <div className="filter mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="links">
                <a
                  onClick={() => handleFilterClick('All')}
                  className={`filter-btn ${activeFilter === 'All' ? 'active' : ''}`}
                  href="#0"
                  data-filter="*"
                >
                  {t('latestCases.filters.all')}
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('Studio')}
                  className={`filter-btn ${activeFilter === 'Studio' ? 'active' : ''}`}
                  data-filter=".Studio"
                >
                  {t('latestCases.filters.studio')}
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('OneBedroom')}
                  className={`filter-btn ${activeFilter === 'OneBedroom' ? 'active' : ''}`}
                  data-filter=".OneBedroom"
                >
                  {t('latestCases.filters.oneBedroom')}
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('TwoBedroom')}
                  className={`filter-btn ${activeFilter === 'TwoBedroom' ? 'active' : ''}`}
                  data-filter=".TwoBedroom"
                >
                  {t('latestCases.filters.twoBedroom')}
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('Penthouse')}
                  className={`filter-btn ${activeFilter === 'Penthouse' ? 'active' : ''}`}
                  data-filter=".Penthouse"
                >
                  {t('latestCases.filters.penthouse')}
                </a>
              </div>
            </div>
            <div className="cases-content wow fadeInUp slow" data-wow-delay="0.4s">
              <div className="row mixitup" ref={mixitupContainerRef}>
                {data.map((item, i) => {
                  const translatedItem = apartmentsData[i] || {};
                  return (
                    <div key={i} className={`col-lg-4 mix-item ${item.filterKey}`}>
                      <div className="case-card">
                        <a href={item.img} className="img" data-fancybox="cases">
                          <img src={item.img} alt={translatedItem.title || item.title} className="img-cover" />
                        </a>
                        <div className="info">
                          <div className="tags mb-30">
                            <a href="#"> {translatedItem.subTitle || item.subTitle} </a>
                          </div>
                          <h3 className="title fsz-35 mb-20">
                            <a href="#" className="hover-orange1">
                              {translatedItem.title || item.title}
                            </a>
                          </h3>
                          <div className="text color-666">
                            {(translatedItem.desc || item.desc).split('<br />')[0]}
                            <br /> {(translatedItem.desc || item.desc).split('<br />')[1]}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <nav aria-label="Page navigation example">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="fal fa-chevron-left"></i>
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link active" href="#">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      ...
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      15
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="fal fa-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestCases;
